/* eslint-disable no-undef */
/* eslint-disable import/no-cycle */
// import antibodyTime from './antibodyTime'
import waterTime from './waterTime'
import brownianFloat from './brownianFloat'

const isMobileWidth = !!(Math.min(window.screen.width, window.screen.height) < 768)

const getBackgroundY = (target, originY, viewportYPct) => {
  // get percentage of origin height
  const imgHeight = target.offsetHeight
  const heightRatio = imgHeight / 3900

  // get position of point in existing image
  const renderedYPos = heightRatio * originY

  // use current viewport height to calc where to scroll to
  const scrollTo = renderedYPos - (window.innerHeight * viewportYPct)
  return -scrollTo
}

// we have to write this out completely for two different elements so we can pause them
const floater1 = gsap.to('.bigFloater1', {
  x: 'random(-20, 20, 5)',
  y: 'random(-20, 10, 3)',
  ease: 'sine.inOut',
  duration: gsap.utils.random([2, 4]),
  repeat: -1,
  repeatRefresh: true,
})

const floater2 = gsap.to('.bigFloater2', {
  x: 'random(-20, 20, 5)',
  y: 'random(-20, 10, 3)',
  ease: 'sine.inOut',
  duration: gsap.utils.random([2, 4]),
  repeat: -1,
  repeatRefresh: true,
})

// Main Timeline
const mainTime = gsap.timeline({
  id: 'main',
  // smoothChildTiming: true,
  paused: true,
  defaults: {
    ease: 'Power3.inOut',
  },
  onUpdate: () => {
    gsap.to('#progress-indicator', { width: `${mainTime.progress() * 100}%` })
  },
})
  .addLabel('start')
  // fade in intro text
  .from('#intro1 .mainTitle', {
    autoAlpha: 0,
    duration: 0.8,
  })
  .from('#intro1 .subTitle', {
    autoAlpha: 0,
    y: 20,
    duration: 0.6,
  })
  .from(
    '.scrollButton',
    {
      autoAlpha: 0,
      ease: 'power3.easeInOut',
      // delay: 1.4,
      duration: 1,
      y: 4,
    },
    1.5,
  )
  .addLabel('introduction')
  // Title gets out of the way as pinned stuff scrolls
  .to('#intro1 .mainTitle', {
    opacity: 0,
    x: -100,
  })
  .to('#intro1 .subTitle', {
    opacity: 0,
    x: 100,
  })
  .to(
    '.scrollButton',
    {
      autoAlpha: 0,
      duration: 1.3,
    },
    'introduction',
  )
  .to(window, { duration: 0.8, scrollTo: '#intro2', ease: 'Power3.out' }) // scroll to first pinned sentence
  .addLabel('firstText')
  .to(window, {
    duration: 0.8,
    scrollTo: {
      y: '#intro3',
      // offsetY: -window.innerHeight,
    },
    ease: 'Power3.out',
  })
  .addLabel('secondText')
  .to(window, { duration: 0.8, scrollTo: '#intro4', ease: 'Power2.out' }) // scroll to second pinned sentence
  .from(
    '.antibodyContainer',
    {
      opacity: 0,
    },
  )
  .to(
    '#antibodyText',
    {
      autoAlpha: 1,
    },
  )
  .addLabel('antibodyAlone')
  .to(
    '.antibodyContainer',
    {
      autoAlpha: 0.3,
      scale: 0.9,
    },
  )
  .from(
    '.biopolymerContainer',
    {
      scale: 0.9,
      autoAlpha: 0,
    },
  )
  .to(
    '#biopolymer-text-1',
    {
      autoAlpha: 1,
    },
  )
  .addLabel('bioPolymerText')
  .to(
    '#biopolymer-text-1',
    {
      autoAlpha: 0,
    },
  )
  .to(
    '#biopolymer-text-2',
    {
      autoAlpha: 1,
    },
  )
  .addLabel('bioPolymerText1')
  .to(
    '.antibodyEndFade',
    {
      autoAlpha: 0,
    },
  )
  .to(
    '.antibodyContainer',
    {
      autoAlpha: 1,
      scale: 1,
    },
  )
  .to(
    '#antibody-img',
    {
      'margin-left': '77%',
      onStart: () => {
      },
    },
  )
  .to(
    '#biopolymer-img',
    {
      'margin-left': isMobileWidth ? '-50%' : '-64%',
    },
    '<',
  )
  .to(
    '#biopolymer-img, #antibody-img',
    {
      filter: 'blur(20px) brightness(2)',
    },
  )
  .to(
    '#intro4 .inner',
    {
      autoAlpha: 0,
    },
  )
  .fromTo( // strawberry appears in flash of light
    '#strawberry-container',
    {
      autoAlpha: 0,
      filter: 'blur(20px) brightness(2)',
    },
    {
      autoAlpha: 1,
      filter: 'blur(0px) brightness(1)',
    },
    '<',
  )
  .call(() => {
    gsap.utils.toArray('.floatMe').forEach(brownianFloat)
  })
  .fromTo(
    '#strawberry-img-titles .h3',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    },
  )
  .addLabel('antibody')
  .to( // reduce strawberry size and fade in supporting text around it
    '#strawberry-container',
    {
      scale: 0.85,
    },
  )
  .fromTo(
    '#strawberry-img-titles .supportingText1',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    },
  )
  .fromTo(
    '#strawberry-img-titles .supportingText2',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    },
  )
  .addLabel('strawberry')
  .to( // fade back strawberry a bit
    '#strawberry-container',
    {
      autoAlpha: 0.2,
    },
  )
  .to(
    '#strawberry-img-titles',
    {
      autoAlpha: 0,
    },
  )
  .to(window, { duration: 1, scrollTo: '#intro5', ease: 'Power3.out' }) // scroll to detail text panel
  .addLabel('fadeBackStrawberry')
  .fromTo( // scroll in the water background
    '.background_Abc',
    {
      top: '100%',
      duration: 1,
    },
    {
      top: '0%',
    },
  )
  .fromTo( // scroll out the intro background at the same time, note the same easing
    '.background_Intro',
    {
      top: '0%',
      duration: 1,
    },
    {
      top: '-100%',
    },
    '<',
  )
  .to(window, { scrollTo: '#abc2', duration: 1 }, '<') // scroll up to the next panel
  .to( // fade strawberry back in to 100%. It's the star!
    '#strawberry-container',
    {
      autoAlpha: 1,
      top: '50%',
      left: '50%',
      y: '-50%',
      x: '-50%',
    },
  )
  .addLabel('platform')
  .to( // move strawberry to lower left corner
    '#strawberry-container',
    {
      scale: 0.6,
      rotate: 23,
      top: '97%',
      left: '5%',
    },
  )
  .to(window, { duration: 0.8, scrollTo: '#water' }, '<') // scroll to follow the water
  .to( // parallax up the background with the wavy bottom
    '.background_Abc',
    {
      top: '-110%',
      duration: 0.8,

      immediateRender: false,
    },
    '-=0.4',
  )
  .add(waterTime()) // roll in the follow the water text
  .addLabel('followWater')
  .to( // Scroll out of the water section
    '.background_Abc',
    {
      top: '-150%',
      duration: 0.8,

    },
  )
  .to(window, { duration: 1, scrollTo: '#water4', ease: 'Power3.easeInOut' }, '-=0.6') // scroll to new section
  .to( // strawberry moves to stage right
    '#strawberry-container',
    {
      scale: 0.85,
      rotate: 0,
      top: '50%',
      left: '70%',
    },
    '-=0.4',
  )
  .to(
    '#backgrounds .background_Water',
    {
      background: 'linear-gradient(180deg, #225586 0%, #5E6A7D 100%)',
      duration: 1,
    },
    '<',
  )
  .to(
    '.curvedBottom',
    {
      autoAlpha: 0,
      duration: 1,
    },
    '<',
  )
  .addLabel('zwitterion')
  .to( // strawberry slides up out of viewport
    '#strawberry-container',
    {
      top: '-100%',
      duration: 0.8,
      ease: 'sine.inOut',
    },
  )
  .set( // now move it to the right out of the viewport so it can slide in from there later
    '#strawberry-container',
    {
      top: '50%',
      left: '150%',
    },
  )
  .to(window, { duration: 1.2, scrollTo: '#water6', ease: 'Power3.easeInOut' }) // scroll down to show next content
  .fromTo(
    '#cell-membrane-blend-overlay, #cell-membrane-gray-matte',
    {
      top: '115%',
    },
    {
      top: '-15%',
      duration: 1.15,
      ease: 'Power3.easeInOut',
    },
    '<',
  )
  .from( // fade in supporting text
    '#water6 .supportingText > p',
    {
      autoAlpha: 0,
      stagger: 0.8,
    },
  )
  .to( // pedestal down on big cell membrane image
    '#cell-membrane-img',
    {
      duration: 1.6,
      y: '0%',
      scale: 1,
    },
  )
  // .to(
  //   '#backgrounds .background_Water',
  //   {

  //     // background: 'linear-gradient(172.27deg, #57667E 28.95%, #2A3D59 69.87%, #0F2547 101.56%)',
  //     duration: 1,
  //   },
  //   '<',
  // )
  .addLabel('zwitterionText')
  .to( // get the next graf of text
    '#water6 .supportingText > p',
    {
      autoAlpha: 0,
    },
  )
  .from( // fade in the next couple grafs
    '#water6 .secondaryText p',
    {
      autoAlpha: 0,
      stagger: 0.8,
    },
  )
  .to( // fade back cell membrane
    '#cell-membrane-img',
    {
      autoAlpha: 0,
      duration: 1,
    },
    '<',
  )
  .to( // fade in cell membrane with aura at same time
    '#cell-membrane-color-img',
    {
      autoAlpha: 1,
      duration: 1,
    },
    '-=1.4',
  )
  .addLabel('zwitterionRole')
  .to( // fade out the supporting text
    '#water6 .supportingText',
    {
      autoAlpha: 0,
    },
  )
  .to( // fade in infobox
    '#water6 .infoBox',
    {
      autoAlpha: 1,
    },
  )
  .to( // fade in detail inset
    '.cellMembraneDetail',
    {
      scale: 1,
      autoAlpha: 1,
    },
    '<',
  )
  .addLabel('zwitterionDetail')
  .to( // fade out inset and box
    '#water6 .infoBox, .cellMembraneDetail',
    {
      autoAlpha: 0,
      duration: 0.25,
    },
  )
  .fromTo( // wipe new BG in from right
    '.background_Zwitterion',
    {
      x: '100%',
    },
    {
      x: '0%',
    },
  )
  .to( // swap out zwitterion headers
    '#water6 .primaryHeader',
    {
      opacity: 0,
    },
  )
  .to( // swap out zwitterion headers
    '#water6 .secondaryHeader',
    {
      autoAlpha: 1,
    },
    '<',
  )
  .to( // strawberry comes back in from offscreen right to stage left.
    '#strawberry-container',
    {
      top: '50%',
      left: '20%',
      duration: 1,

    },
  )
  .to( // fade in strawberry details after wipe
    '.strawberryZoom',
    {
      autoAlpha: 1,
    },
  )
  .to(
    '.strawberryZoomText',
    {
      autoAlpha: 1,
    },
  )
  .addLabel('zwitterionWipe')
  .to(
    '.strawberryZoom',
    {
      autoAlpha: 0,
      duration: 0.2,
    },
  )
  .to(
    '.strawberryZoomText',
    {
      autoAlpha: 0,
      duration: 0.1,
    },
  )
  .to( // strawberry runs down to lower right corner once more
    '#strawberry-container',
    {
      rotate: -23,
      top: '97%',
      left: '95%',
      duration: 0.8,
    },
  )
  .to(window, { duration: 1, scrollTo: '#structured-water' }, '<') // scroll in structured water
  .addLabel('structured-water')
  .to(window, { duration: 2, scrollTo: '#eye', ease: 'Power3.easeInOut' }) // scroll to eyeball
  .fromTo(
    '#eyeball-container',
    {
      y: '100%',
    },
    {
      y: '50%',
      width: '100%',
      ease: 'Power3.out',
      duration: 1,
    },
    '-=0.4',
  )
  .addLabel('eyeball')
  .to(
    '#eye1 h3',
    {
      autoAlpha: 0,
    },
  )
  .to(
    '#eyeball-container',
    {
      y: '20%',
      x: -100,
      width: isMobileWidth ? '85%' : '43%',
    },
    '-=0.2',
  )
  // .addLabel('eyeballLegend')
  .to(
    '#eyeball-legend',
    {
      autoAlpha: 1,
      delay: 0.2,
      duration: 0.5,
      ease: 'Power3.in',
    },
  )
  .fromTo(
    '#eyeball-img-dye',
    {
      '-webkit-mask-image': 'linear-gradient(225deg, black 0%, transparent 0%)',
      maskImage: 'linear-gradient(225deg, black 0%, transparent 0%)',
    },
    {
      '-webkit-mask-image': 'linear-gradient(225deg, black 25%, transparent 75%)',
      maskImage: 'linear-gradient(225deg, black 25%, transparent 75%)',
      duration: 2.5,
      ease: 'Power3.easeIn',
    },
    '-=0.2',
  )
  .to(
    '#eyeball-img-dye',
    {
      '-webkit-mask-image': 'linear-gradient(225deg, black 50%, transparent 75%)',
      maskImage: 'linear-gradient(225deg, black 50%, transparent 75%)',
      duration: 1,
      ease: 'Power3.out',
    },
  )
  .to(
    '#eyeball-legend-2',
    {
      autoAlpha: 1,
      delay: 0.2,
      duration: 0.5,
      ease: 'Power3.in',
    },
    '-=1.4',
  )
  .addLabel('injectedEyeball')
  .to( // fade in overlay
    '#eyeball-overlay',
    {
      autoAlpha: 1,
    },
  )
  .to(
    '#eyeball-legend, #eyeball-legend-2',
    { // fade out legend
      autoAlpha: 0.5,
      ease: 'linear',
    },
    '<',
  )
  .addLabel('unique-properties')
  .to(window, { duration: 1, scrollTo: '#non-adsorptive', ease: 'Power3.easeInOut' }) // scroll to last big section
  .set( // set overlay to 0, no longer used
    '#eyeball-overlay',
    {
      autoAlpha: 0,
    },
  )
  .to( // fade in insets for target and strawberry dots
    '#target-label .targetLabelTextWrap',
    {
      autoAlpha: 1,
    },
  )
  .to(
    '#target-label .targetLabelTriangle',
    {
      autoAlpha: 1,
    },
    '<',
  )
  .to(
    '#strawberry-focus .strawberryFocusTriangle',
    {
      autoAlpha: 1,
      delay: 1.5,
    },
  )
  .to(
    '#strawberry-focus .strawberryFocusWrap',
    {
      autoAlpha: 1,
    },
    '<',
  )
  .addLabel('target')
  .to( // fade out target and strawberry insets
    '#target-label .targetLabelTextWrap',
    {
      autoAlpha: 0,
    },
  )
  .to(
    '#target-label .targetLabelTriangle',
    {
      autoAlpha: 0,
    },
    '<',
  )
  .to(
    '#strawberry-focus .strawberryFocusTriangle',
    {
      autoAlpha: 0,
      delay: 0.5,
    },
  )
  .to(
    '#strawberry-focus .strawberryFocusWrap',
    {
      autoAlpha: 0,
    },
    '<',
  )
  .to( // move background down a scosch
    '#non-adsorptive-bg-container #bg-inner',
    {
      y: (index, target) => getBackgroundY(target, 1118, 0.5),
      duration: 0.8,

    },
  )
  .to(
    '#target-label',
    { // fake parallax
      y: '-200%',
    },
    '<',
  )
  .to(
    '#strawberry-focus',
    { // fake parallax
      y: '-100%',
    },
    '<',
  )
  .fromTo( // parallaxy molecules moving
    '#floating-molecules',
    {
      y: '0%',
    },
    {
      y: '-22.222%',
      duration: 0.8,

    },
    '<',
  )
  .to( // bring in Nonadsorptive text box
    '#nonadsorptive-text',
    {
      autoAlpha: 1,
      y: 15,
    },
  )
  .addLabel('non-adsorptive')
  .to( // fade out text box
    '#nonadsorptive-text',
    {
      autoAlpha: 0,
      y: -15,
    },
  )
  .to( // move background down a bit more
    '#non-adsorptive-bg-container #bg-inner',
    {
      y: (index, target) => getBackgroundY(target, 1555, 0.5),
      duration: 0.8,

    },
  )
  .to( // parallaxy molecules moving
    '#floating-molecules',
    {
      y: '-44.4444%',
      duration: 0.8,
    },
    '<',
  )
  .fromTo( // show the ABC squeeze inset
    '#bioconjugate-squeeze',
    {
      autoAlpha: 0,
      y: '-45%',
    },
    {
      autoAlpha: 1,
      y: '-50%',
    },
  )
  .fromTo( // Show supporting text for squeeze inset
    '#bioconjugate-squeeze-txt',
    {
      autoAlpha: 0,
      x: '-45%',
    },
    {
      autoAlpha: 1,
      x: '-50%',
    },
  )
  .addLabel('squeeze')
  .to( // fade stuff up and out
    '#bioconjugate-squeeze-txt',
    {
      autoAlpha: 0,
      x: '-55%',
    },
  )
  .to(
    '#bioconjugate-squeeze',
    {
      autoAlpha: 0,
      y: '-55%',
    },
  )
  .to( // move background down a bit more
    '#non-adsorptive-bg-container #bg-inner',
    {
      y: (index, target) => getBackgroundY(target, 2859, 0.6),
      duration: 1.2,

    },
  )
  .to( // parallaxy molecules moving
    '#floating-molecules',
    {
      y: '-66.6666%',
      duration: 1.2,

    },
    '<',
  )
  .fromTo( // bring in frictionless text and inset
    '#frictionless-text',
    {
      autoAlpha: 0,
      x: isMobileWidth ? null : 15,
    },
    {
      autoAlpha: 1,
      x: isMobileWidth ? null : 0,
    },
  )
  .fromTo(
    '#strawberry-frictionless',
    {
      autoAlpha: 0,
      scale: 0.7,
    },
    {
      autoAlpha: 1,
      scale: 1,
      ease: 'elastic.out(1, 0.3)',
      duration: 0.5,
    },
  )
  .addLabel('frictionless')
  .to( // fade out frictionless shazz
    '#frictionless-text',
    {
      autoAlpha: 0,
      x: isMobileWidth ? null : 15,
    },
  )
  .to(
    '#strawberry-frictionless',
    {
      autoAlpha: 0,
    },
    '-=0.3',
  )
  .to( // Overlay time
    '#docking-overlay',
    {
      autoAlpha: 1,
    },
  )
  .addLabel('dockingText')
  .to( // next few things fade in/out the intro text on the overlay
    '#docking-overlay .introText',
    {
      autoAlpha: 0,
    },
  )
  .to(
    '#docking-overlay .secondaryText',
    {
      autoAlpha: 1,
    },
  )
  .addLabel('dockingText2')
  .to(
    '#docking-overlay .secondaryText',
    {
      autoAlpha: 0,
    },
  )
  .set( // bring forward the layer with the floating molecules
    '#floating-molecules',
    {
      zIndex: 4,
    },
  )
  .to( // show the molecules instead of the dots
    '.floatingStrawberry .moleculeImg, .floatingTarget .moleculeImg',
    {
      autoAlpha: 1,
      delay: 1.5,
    },
  )
  .to(
    '.floatingStrawberry .dot, .floatingTarget .dot',
    {
      autoAlpha: 0,
    },
    '<',
  )
  .to( // now start boinging these mothers in one by one
    '#floating-target-1',
    {
      width: isMobileWidth ? '20%' : '8%', //  63 : 126,
      ease: 'elastic.out(1, 0.3)',
    },
  )
  .to(
    '#floating-target-5',
    {
      width: 90,
      ease: 'elastic.out(1, 0.3)',
    },
    '-=0.4',
  )
  .to(
    '#floating-target-3',
    {
      width: 50,
      ease: 'elastic.out(1, 0.3)',
    },
    '-=0.2',
  )
  .to(
    '#floating-target-7',
    {
      width: 110,
      ease: 'elastic.out(1, 0.3)',
    },
    '+=0.2',
  )
  .to( // now the strawberries
    '#floating-strawberry-8',
    {
      width: 95,
      ease: 'elastic.out(1, 0.3)',
      duration: 0.8,
    },
  )
  .to(
    '#floating-strawberry-9',
    {
      width: 170,
      ease: 'elastic.out(1, 0.3)',
    },
    '-=0.4',
  )
  .to(
    '#floating-strawberry-10',
    {
      width: 90,
      ease: 'elastic.out(1, 0.3)',
    },
    '-=0.4',
  )
  .to(
    '#floating-strawberry-5',
    {
      width: 200,
      ease: 'elastic.out(1, 0.3)',
    },
    '-=0.2',
  )
  .to( // big one last
    '#floating-strawberry-1',
    {
      width: isMobileWidth ? '80%' : '40%', // isMobileWidth ? 320 : 640,
      ease: 'elastic.out(1, 0.3)',
      duration: 0.7,
    },
    '+=0.2',
  )
  .addLabel('binding')
  .to( // fade out all but the big floating molecules
    '.floatingFadeout',
    {
      autoAlpha: 0,
      onComplete: () => {
        // Hacky stuff here... pausing these breaks the scroll lock on iOS, so...
        if (!isMobileWidth) {
          floater1.pause()
          floater2.pause()
        }
      },
    },
  )
  .to( // move the floaters to the right so we can connect them
    '#floating-target-1',
    {
      left: isMobileWidth ? null : '72%',
    },
  )
  .to(
    '#floating-strawberry-1',
    {
      left: isMobileWidth ? null : '47%',
    },
    '-=0.4',
  )
  .to( // connecting with the dashed curved line
    '#dashed-lines',
    {
      autoAlpha: 1,
    },
  )
  .to( // stereoscopic header text
    '#stereo-header',
    {
      autoAlpha: 1,
    },
  )
  .to( // fade out supporting text
    '.supportingDockText',
    {
      autoAlpha: 1,
    },
  )
  .addLabel('bound')
  .to( // fade out supporting text
    '.supportingDockText',
    {
      autoAlpha: 0,
    },
  )
  .to( // fade out the molecules and header
    '#floating-molecules, #stereo-header, #target-label, #strawberry-focus',
    {
      autoAlpha: 0,
      duration: 0.6,
    },
  )
  .to( // animate binding
    '#floating-strawberry-1',
    {
      rotate: -50,
      scale: 0.8,
    },
    '<',
  )
  .to(
    '#floating-target-1',
    {
      rotate: 24,
      scale: 0.75,
      y: -15,
      left: '70%',
    },
    '<',
  )
  .to( // overview of the binding process
    '.bindingOverviewImg',
    {
      autoAlpha: 1,
    },
    '<',
  )
  .to(
    '#binding-detail',
    {
      autoAlpha: 1,
    },
    '-=0.1',
  )
  .to( // show supporting text describing the binding process
    '.bindingSupportingText',
    {
      autoAlpha: 1,
    },
  )
  .addLabel('dockingInset')
  .to( // fade out binding overview
    '.bindingOverviewImg',
    {
      autoAlpha: 0,
    },
  )
  .fromTo(
    '.boundOverviewImg',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    },
    '<',
  )
  .to(
    '.bindingDetailImg .binding',
    {
      autoAlpha: 0,
    },
    '<',
  )
  .fromTo(
    '.bindingDetailImg .bound',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    },
    '<',
  )
  .to(
    '.bindingSupportingText .primary',
    {
      autoAlpha: 0,
    },
    '<',
  )
  .fromTo( // and finally fade in secondary text
    '.bindingSupportingText .secondary',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    },
    '<',
  )
  .addLabel('docking')
  .to( // bye bye overlay
    '#docking-overlay',
    {
      autoAlpha: 0,
    },
  )
  .to( // can see the nice background again, we go to the bottom
    '#non-adsorptive-bg-container #bg-inner',
    {
      y: (index, target) => getBackgroundY(target, 3900, 1),
      duration: 0.8,

    },
  )
  .to( // fade in clearance stuff
    '#clearance-section #leaving-eye',
    {
      y: -20,
      autoAlpha: 1,
      duration: 1,
    },
  )
  .to(
    '#dots-tall-bg',
    {
      autoAlpha: 0,
    },
    '<',
  )
  .to(
    '#clearance-section .clearanceInset',
    {
      autoAlpha: 1,
    },
  )
  .to(
    '#clearance-section .clearanceText',
    {
      autoAlpha: 1,
      delay: 0.5,
    },
  )
  .to(
    '#clearance-section .clearanceHeaderSecondaryText',
    {
      autoAlpha: 1,
      duration: 0.6,
      delay: 0.8,
    },
  )
  .addLabel('clearanceIntro')
  .fromTo(
    '.clearanceInset .labelText',
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    },
  )
  .fromTo(
    '#clearing-2',
    {
      top: '38%',
      left: '15%',
    },
    {
      top: '84%',
      left: '119%',
      duration: 1.2,
      ease: 'Power2.easeIn',
    },
    '<',
  )
  .fromTo(
    '#clearing-4',
    {
      top: '59%',
      left: '58%',
    },
    {
      top: '90%',
      left: '119%',
      duration: 1.1,
      ease: 'Power2.easeIn',
    },
    '-=.8',
  )
  .fromTo(
    '#clearing-1',
    {
      top: '18%',
      left: '5%',
    },
    {
      top: '79%',
      left: '110%',
      duration: 1,
      ease: 'Power2.easeIn',
    },
    '-=1.1',
  )
  .fromTo(
    '#clearing-5',
    {
      top: '58%',
      left: '83%',
    },
    {
      top: '89%',
      left: '110%',
      duration: 0.6,
      ease: 'Power2.easeIn',
    },
    '-=1.1',
  )
  .fromTo(
    '#clearing-3',
    {
      top: '67%',
      left: '50%',
    },
    {
      top: '79%',
      left: '110%',
      duration: 0.9,
      ease: 'Power2.easeIn',
    },
    '-=1.1',
  )
  .addLabel('cleared')
  .to(window, { scrollTo: '#outro' }) // finish this up, move to last panel
  .to( // move strawberry back to center stage
    '#strawberry-container',
    {
      rotate: 0,
      top: '60%',
      left: '50%',
    },
    '-=0.2',
  )
  .addLabel('conclusion')
export default mainTime
